import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import roundedSkill from "../../images/hireDeveloper/rounded_skill.svg";

const Candidateskills = () => {
  useEffect(() => {
    document.body.className = "";
  }, []);
  return (
    <>
      <section className="candidateSkillSection">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 col-md-6">
              <div className="heading">
                <h3 data-aos="slide-right">
                  Our objective is to provide ready to fit resources
                </h3>
                <p data-aos="slide-right">
                  We will help you with providing well skilled and ready to fit
                  resources who will work with a mind-set to finish the tasks up
                  to full satisfaction of clients.
                </p>
                <Link
                  to="/HireDeveloper"
                  className="btn"
                  data-aos="slide-right"
                >
                  <span>Hire Top Developers</span>
                </Link>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 ml-auto" data-aos="zoom-in">
              <img
                src={roundedSkill}
                className="img-fluid"
                alt="Hire Fullstack Developers"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Candidateskills;
